var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { get } from 'lodash-es';
import ImagePreview from '../ImagePreview';
import { CameraIcon } from '../../shared/icons';
var Label = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n\n  ", " {\n    position: absolute;\n    left: calc(84% - 18px);\n    top: calc(84% - 18px);\n  }\n\n  input { display: none; }\n"], ["\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n\n  ", " {\n    position: absolute;\n    left: calc(84% - 18px);\n    top: calc(84% - 18px);\n  }\n\n  input { display: none; }\n"])), CameraIcon);
var ImageUpload = function (_a) {
    var _b = _a.src, src = _b === void 0 ? '' : _b, typeOfFit = _a.typeOfFit, _c = _a.size, size = _c === void 0 ? '200px' : _c, onChange = _a.onChange, _d = _a.showCamera, showCamera = _d === void 0 ? true : _d, children = _a.children, props = __rest(_a, ["src", "typeOfFit", "size", "onChange", "showCamera", "children"]);
    function changePhoto(e) {
        e.preventDefault();
        if (get(e, 'target.files', []).length) {
            var reader_1 = new FileReader();
            var file_1 = e.target.files[0];
            reader_1.onloadend = function () {
                onChange && onChange({ file: file_1, src: reader_1.result });
            };
            reader_1.readAsDataURL(file_1);
        }
    }
    return (React.createElement(Label, __assign({ htmlFor: "photoUpload" }, props),
        src ? (React.createElement(ImagePreview, { size: size, src: src, typeOfFit: typeOfFit })) : null,
        showCamera ? React.createElement(CameraIcon, null) : null,
        children,
        React.createElement("input", { id: "photoUpload", type: "file", onChange: changePhoto })));
};
export default styled(ImageUpload)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2;
